import React from 'react';

class DisciplinesList extends React.Component {

  render() {
    var data = this.props.data || [];

    return <div className={data.length === 1 ? 'degrees__list one-child-only' : 'degrees__list'}>
      {data.map((item, i) => {
        return item.units_count === "0" ? null : this.props.createDiscipline(item, i);
      })}
    </div>;
  }
}

DisciplinesList.propTypes = {
  data:             React.PropTypes.array.isRequired,
  createDiscipline: React.PropTypes.func.isRequired
};

export default DisciplinesList;
